import type { RequestException } from '@eika-infrastruktur/request';
import type { AccountForChildEligibilityDetails } from '@generated-types';
import { getChildEligibilities } from '@react-query/services/child-eligibilities';
import { useQuery } from '@tanstack/react-query';
import { formatEligibilityPersonNames } from '@utils/name-utils';

export const useChildEligibilities = () => {
    return useQuery<AccountForChildEligibilityDetails[], RequestException>({
        queryKey: ['child-eligibilities'],
        queryFn: () => getChildEligibilities(),
        select: (data) => data.map(formatEligibilityPersonNames),
    });
};
